import {SortDirection} from "../../data-structures/sort";
import {Column} from "../manager/columns/types";
import {SystemStatusGroup} from "../../gd/const/system-status";

export type TableSortConfig = {
    id              : fieldId | null,
    label           : string,
    defaultSort     : SortDirection
    info            : string
}

export type TableDefaultAppSettings = {
    columns                 : any // _.map(['2','12','4','3','6'], id=>({id: id/*, aggregate: null*/})),
    systemStatusFilter      : SystemStatusGroup, // used is task table to show hide archived tasks
    sorting                 : any,  // current sorting value
    filters                 : any,
    areEmptyFoldersHidden?  : boolean,
}


export type TableConfig = {

    columns             : Column[],              // all available columns array
    sortOptions         : TableSortConfig[],                // all available sort options

    defaultAppSettings  : any // defaultAppSettings import defaultAppSettings from "./settings/default-settings";

}

// deprecated - use SystemStatusGroup
export enum TableViewSystemStatus {
    OPEN        = 'open',
    CLOSED      = 'closed',
    ALL         = 'all'
}

export enum TableRenderMode {
    PERFORMANCE         = 'performance',
    STANDARD            = 'standard'
}

export enum RenderModeOption {
    AUTO                = 'auto',
    PERFORMANCE         = 'performance',
    STANDARD            = 'standard'
}